// src/Features/Projects/components/ProjectCreateForm/projectCreateForm.definitions.ts
import clsx from "clsx";

// Placeholders dos campos
export const FORM_PLACEHOLDERS = {
  name: "Ex: Sistema de Gestão de Clientes",
  initialDescription:
    "Descreva sua ideia de projeto... \n\nEx: Preciso de um sistema para gerenciar meus clientes, com cadastro, histórico de interações, controle de vendas e relatórios. O sistema deve ser web, fácil de usar e integrar com WhatsApp.",
} as const;

// Classes CSS para diferentes estados
export function getFormFieldClasses(
  hasError: boolean,
  disabled: boolean = false
): string {
  return clsx(
    // Classes base
    "w-full px-4 py-3 font-montserrat rounded-xl border transition-all duration-200",
    "placeholder:text-raro-gray-400 focus:outline-none focus:ring-2",

    // Estados condicionais
    {
      // Estado normal
      "border-raro-gray-300 focus:border-primary-500 focus:ring-primary-500/20 bg-white":
        !hasError && !disabled,

      // Estado de erro
      "border-red-500 focus:border-red-500 focus:ring-red-500/20 bg-red-50":
        hasError && !disabled,

      // Estado desabilitado
      "bg-raro-gray-50 border-raro-gray-200 text-raro-gray-500 cursor-not-allowed":
        disabled,
    }
  );
}

export function getButtonClasses(
  variant: "primary" | "secondary" = "primary",
  size: "sm" | "md" | "lg" = "md",
  loading: boolean = false,
  disabled: boolean = false
): string {
  return clsx(
    // Classes base
    "inline-flex items-center justify-center font-montserrat font-semibold rounded-xl transition-all duration-200",
    "focus:outline-none focus:ring-2 focus:ring-offset-2",

    // Tamanhos
    {
      "px-3 py-1.5 text-sm": size === "sm",
      "px-4 py-2.5 text-base": size === "md",
      "px-6 py-3 text-base": size === "lg",
    },

    // Variantes
    {
      // Primary
      "bg-primary-500 hover:bg-primary-600 text-white focus:ring-primary-500":
        variant === "primary" && !disabled && !loading,

      // Secondary
      "bg-white border-2 border-primary-500 text-primary-500 hover:bg-primary-50 focus:ring-primary-500":
        variant === "secondary" && !disabled && !loading,
    },

    // Estados especiais
    {
      "opacity-50 cursor-not-allowed": disabled || loading,
      "animate-pulse": loading,
    }
  );
}

// Validações customizadas
export const VALIDATION_RULES = {
  name: {
    minLength: 3,
    maxLength: 100,
  },
  initialDescription: {
    minLength: 10,
    maxLength: 2000,
  },
} as const;

// Mensagens de feedback
export const FEEDBACK_MESSAGES = {
  success: {
    created: "Projeto criado com sucesso!",
    expanded: "Descrição expandida pela IA!",
  },
  error: {
    createFailed: "Erro ao criar projeto. Tente novamente.",
    expandFailed: "Erro ao expandir descrição. Tente novamente.",
    aiNotConfigured: "IA não está configurada.",
  },
  info: {
    aiRecommendation: "Recomendado: deixe a IA melhorar sua descrição primeiro",
    fillDescription: "Descreva sua ideia para ativar a expansão com IA",
    unsavedChanges:
      "Você tem alterações não salvas. Deseja realmente cancelar?",
  },
} as const;

// Configurações da IA
export const AI_CONFIG = {
  minDescriptionLength: 10,
  maxDescriptionLength: 2000,
  expandedMaxLength: 5000,
  suggestNameWhenEmpty: true,
} as const;

// Ícones utilizados no componente
export const FORM_ICONS = {
  project: "PlusIcon",
  ai: "SparklesIcon",
  document: "DocumentTextIcon",
  arrow: "ArrowRightIcon",
  close: "XMarkIcon",
} as const;
